import QorusClient from "@/api/clients/QorusClient";
import { Category } from "@/models/category";

/**
 *  Qorus API about categories
 */
export default class CategoryService {
  static of(): CategoryService {
    return new CategoryService();
  }

  /**
   * Get tree of categories
   * @return CategoryDTO Tree of categories
   */
  getTree(): Promise<Category> {

    return QorusClient.of().get("categories", {}).then(
      (data) => {
        return data;
      },
      data => {
        throw data;
      },
    );
  }
}